function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5893 1.63685C13.9551 2.6911 15.118 4.23564 15.9532 6.16727C16.0156 6.31389 16.0156 6.48533 15.9532 6.62497C14.2829 10.4882 11.3093 12.8 8 12.8H7.9922C4.69073 12.8 1.71707 10.4882 0.0468293 6.62497C-0.0156098 6.48533 -0.0156098 6.31389 0.0468293 6.16727C1.71707 2.30322 4.69073 0 7.9922 0H8C9.65463 0 11.2234 0.574061 12.5893 1.63685ZM4.87813 6.4C4.87813 8.10667 6.2752 9.49527 8.00008 9.49527C9.71715 9.49527 11.1142 8.10667 11.1142 6.4C11.1142 4.68558 9.71715 3.29697 8.00008 3.29697C6.2752 3.29697 4.87813 4.68558 4.87813 6.4Z",
  fill: "#200E32"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.94493 6.39643C9.94493 7.45921 9.07078 8.32806 8.00151 8.32806C6.92444 8.32806 6.05029 7.45921 6.05029 6.39643C6.05029 6.26455 6.0659 6.1412 6.08932 6.01708H6.12834C6.99468 6.01708 7.69712 5.33441 7.72834 4.4803C7.8142 4.46556 7.90785 4.45703 8.00151 4.45703C9.07078 4.45703 9.94493 5.32588 9.94493 6.39643Z",
  fill: "#200E32"
});

function SvgShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.33e6cee4.svg";
export { ForwardRef as ReactComponent };